"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = exports.CircleButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _excluded = ["onClick", "icon", "size", "iconColor", "onMouseEnter", "setText", "disableIconButton", "hoverColor"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CircleButton = _styledComponents["default"].button.withConfig({
  displayName: "IconButton__CircleButton",
  componentId: "sc-rvk2ch-0"
})(["display:flex;align-items:center;justify-content:center;width:", "px;height:", "px;border:0;border-radius:99px;background:transparent;flex-shrink:0;right:", ";top:", ";background-position:center;transition:background 0s;&:hover{background:", ";transition:0.4s;cursor:pointer;}&:active{background-color:", ";background-size:100%;transition:background 0s;}&:disabled{background:transparent;cursor:default;}"], function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var right = _ref3.right;
  return right;
}, function (_ref4) {
  var top = _ref4.top;
  return top;
}, function (_ref5) {
  var hoverColor = _ref5.hoverColor;
  return (hoverColor || "#8e8e8e") + " radial-gradient(circle, transparent 1%, #686868 1%)center/15000%;";
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.dark[6];
});

exports.CircleButton = CircleButton;

var IconButton = function IconButton(_ref7) {
  var onClick = _ref7.onClick,
      icon = _ref7.icon,
      size = _ref7.size,
      iconColor = _ref7.iconColor,
      _onMouseEnter = _ref7.onMouseEnter,
      setText = _ref7.setText,
      _ref7$disableIconButt = _ref7.disableIconButton,
      disableIconButton = _ref7$disableIconButt === void 0 ? false : _ref7$disableIconButt,
      hoverColor = _ref7.hoverColor,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref7, _excluded);
  (0, _react.useEffect)(function () {
    if (disableIconButton) setText(false);
  }, [disableIconButton]);
  return /*#__PURE__*/_react["default"].createElement(CircleButton, (0, _extends2["default"])({
    onClick: onClick,
    size: size,
    onMouseEnter: function onMouseEnter() {
      return _onMouseEnter ? setText(_onMouseEnter) : null;
    },
    onMouseLeave: function onMouseLeave() {
      return setText && setText(false);
    },
    disabled: disableIconButton,
    hoverColor: hoverColor
  }, props), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: icon,
    height: "100%",
    color: iconColor
  }));
};

IconButton.defaultProps = {
  size: 48
};
IconButton.propTypes = {
  onClick: _propTypes["default"].func,
  icon: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].number
};
var _default = IconButton;
exports["default"] = _default;